module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Stammheim_COA-e60f8c5277876018ec7eacc671ff51d9.svg";